
import { useState, useRef } from "react";

export function useExploreState() {
  // Track initialization status
  const [isInitialized, setIsInitialized] = useState(false);
  // Track if we're filtering by category (for UI loading states)
  const [isCategoryFiltering, setIsCategoryFiltering] = useState(false);
  // Track if categories are loaded (new flag for UI visibility)
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  
  // New filter states
  const [selectedSort, setSelectedSort] = useState('relevance');
  const [selectedTimeFilter, setSelectedTimeFilter] = useState('');
  
  // Category processing flag
  const isCategoryProcessing = useRef(false);
  const initialLoadAttempted = useRef(false);
  const categoryChangeTimeout = useRef<NodeJS.Timeout | null>(null);
  const loadDebounceTimer = useRef<NodeJS.Timeout | null>(null);
  const lastDepsString = useRef("");
  const manualLoadTriggered = useRef(false);

  return {
    isInitialized,
    setIsInitialized,
    isCategoryFiltering,
    setIsCategoryFiltering,
    categoriesLoaded,
    setCategoriesLoaded,
    selectedSort,
    setSelectedSort,
    selectedTimeFilter,
    setSelectedTimeFilter,
    isCategoryProcessing,
    initialLoadAttempted,
    categoryChangeTimeout,
    loadDebounceTimer,
    lastDepsString,
    manualLoadTriggered
  };
}
